export default __webpack_public_path__ + "static/media/payment.82c3fc52.svg";